<app-header/>
<div class="top_padding5">
    <!-- alert model -->
<div class="modal fade" id="alertModel" tabindex="-1" aria-labelledby="alertModelLabel" aria-hidden="true" #alertModal>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="alert alert-success alert-dismissible fade show text_align-center" role="alert">
                    <strong>Success!</strong> Thank you for your demo request. The ChemRobotics® team will reach out to
                    you shortly.
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Demo request -->
<div class="demo_request" id="demo-form" aria-labelledby="demo_request" aria-hidden="true">
    <div class="  ">
        <div class=" p-x-20 bg_1 w-100">
            <div class="p-x-20">
                <div class="dis-grid-1 demo_request_head">
                    <div class="header_bottom_logo">
                        <img class="header_bottom_logo_img" src="../../../assets/img/logo.png" alt="Logo" />
                    </div>
                    <div class="dis-flex-2">
                        <span class="text_blue_9">Request a Demo</span>
                    </div>
                </div>
                <div class="p-top-20">
                    <div class="dis-flex-4 p-x-15">
                        <div>
                            <span class="text_black_14">Choose Below Verticals For Demo:-</span>
                        </div>
                        <div class="selected-count flex-1" *ngIf="selectedCountdemo > 0">
                            {{ selectedCountdemo }} selected
                        </div>
                        <div class="selected-count flex-1" *ngIf="selectedCountdemo === 0">
                            0 selected
                        </div>
                    </div>
                </div>
                <div>
                    <form class="" [formGroup]="demorequestForm" (ngSubmit)="submit_demo_form()">
                        <div class="dis-flex-7 flex-wrap p-top-24 demo_request_checkbox">
                            <ng-container *ngFor="let vertical of verticals; let i = index">
                                <div class="p-x-25 p-y-11 dis-flex-4 border_blue_1 border-radius-22 m-r-16 m-b-16"
                                    [ngClass]="{'bg_1': !vertical.checked, 'bg_3': vertical.checked, 'text_blue_5': !vertical.checked, 'text_white_9': vertical.checked}">
                                    <input type="checkbox" id="checkbox{{ i }}" name="checkbox{{ i }}"
                                        (change)="toggleVerticalChecked(i)" [checked]="vertical.checked">
                                    <label for="checkbox{{ i }}" class="p-l-10">{{ vertical.vertical }}</label>
                                </div>
                            </ng-container>
                        </div>
                        <div class=" demo_request_form">
                            <div class="dis-block-1 p-top-18 p-x-15">
                                <label for="demoDate1" class="dis-flex-4 text_grey_2">Demo Date*</label>
                                <input type="date" id="demoDate" formControlName="date"
                                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                                    placeholder="Select Demo Date" required>
                                <div *ngIf="demorequestForm.get('date')?.touched && demorequestForm.get('date')?.invalid"
                                    class="text-red-1">
                                    <span *ngIf="demorequestForm.get('date')?.errors?.['required']">Date is
                                        required.</span>
                                </div>
                            </div>
                            <div class="dis-block-1 p-top-18 p-x-15">
                                <label for="demoTime" class="dis-flex-4 text_grey_2">Demo Time*</label>
                                <input type="time" id="demoTime" formControlName="time"
                                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                                    placeholder="Select Demo Time" required>
                                <div *ngIf="demorequestForm.get('time')?.touched && demorequestForm.get('time')?.invalid"
                                    class="text-red-1">
                                    <span *ngIf="demorequestForm.get('time')?.errors?.['required']">Time is
                                        required.</span>
                                </div>
                            </div>
                            <div class="dis-block-1 p-top-18 p-x-15">
                                <label for="name" class="dis-flex-4 text_grey_2">“First Name*</label>
                                <input type="text" formControlName="fname"
                                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                                    placeholder="Enter First Name" required>
                                <div *ngIf="demorequestForm.get('fname')?.touched && demorequestForm.get('fname')?.invalid"
                                    class="text-red-1">
                                    <span *ngIf="demorequestForm.get('fname')?.errors?.['required']">first name is
                                        required.</span>
                                </div>
                            </div>
                            <div class="dis-block-1 p-top-18 p-x-15">
                                <label for="name" class="dis-flex-4 text_grey_2">Last Name*</label>
                                <input type="text" formControlName="lname"
                                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                                    placeholder="Enter Last Name" required>
                                <div *ngIf="demorequestForm.get('lname')?.touched && demorequestForm.get('lname')?.invalid"
                                    class="text-red-1">
                                    <span *ngIf="demorequestForm.get('lname')?.errors?.['required']">last name is
                                        required.</span>
                                </div>
                            </div>
                            <div class="dis-block-1 p-top-18 p-x-15">
                                <label for="email" class="dis-flex-4 text_grey_2">Business email*</label>
                                <input type="email" formControlName="email"
                                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                                    placeholder="Enter Business email" required>
                                <div *ngIf="demorequestForm.get('email')?.touched && demorequestForm.get('email')?.invalid"
                                    class="text-red-1">
                                    <span *ngIf="demorequestForm.get('email')?.errors?.['required']">Email is
                                        required.</span>
                                    <span *ngIf="demorequestForm.get('email')?.errors?.['email']">Invalid email
                                        format.</span>
                                </div>
                            </div>
                            <div class=" dis-block-1 p-top-18 p-x-15">
                                <label class="text_grey_2">Phone*</label>
                                <div class="width-100-per">
                                    <select id="countryCode" formControlName="country_code"
                                    class="text_grey_3 height-40 border-radius-4  p-x-10 width-25-per">
                                    <option *ngFor="let country of countries" [value]="country.code">
                                        {{ country.code }} <!-- Only display the code, since img tag cannot be used within an <option> -->
                                      </option>
                                </select>
                                <input type="tel" name="phone"
                                    class="text_grey_3 height-40 border-radius-4 p-x-15 width-75-per"
                                    placeholder="626 611 7944" formControlName="phone">
                                </div>
                                <div *ngIf="demorequestForm.get('phone')?.touched && demorequestForm.get('phone')?.invalid"
                                    class="text-red-1">
                                    <span *ngIf="demorequestForm.get('phone')?.errors?.['required']">Phone number is
                                        required.</span>
                                    <span *ngIf="demorequestForm.get('phone')?.errors?.['pattern']">Phone number must be
                                        10 digits.</span>
                                </div>
                            </div>
                            <div class="dis-block-1 p-top-18 p-x-15">
                                <label for="jobTitle" class="dis-flex-4 text_grey_2">Job title*</label>
                                <input type="text" formControlName="job"
                                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                                    placeholder="Enter Job Title" required>
                                <div *ngIf="demorequestForm.get('job')?.touched && demorequestForm.get('job')?.invalid"
                                    class="text-red-1">
                                    <span *ngIf="demorequestForm.get('job')?.errors?.['required']">Job is
                                        required.</span>
                                </div>
                            </div>
                            <div class="dis-block-1 p-top-18 p-x-15">
                                <label for="company" class="dis-flex-4 text_grey_2">Company*</label>
                                <input type="text" formControlName="company"
                                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                                    placeholder="Enter Company" required>
                                <div *ngIf="demorequestForm.get('company')?.touched && demorequestForm.get('company')?.invalid"
                                    class="text-red-1">
                                    <span *ngIf="demorequestForm.get('company')?.errors?.['required']">company is
                                        required.</span>
                                </div>
                            </div>
                            <div class="dis-block-1 p-top-18 p-x-15">
                                <label for="country" class="dis-flex-4 text_grey_2">Country*</label>
                                <input type="text" id="country" formControlName="country"
                                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                                    placeholder="Enter Country" required>
                                <div *ngIf="demorequestForm.get('country')?.touched && demorequestForm.get('country')?.invalid"
                                    class="text-red-1">
                                    <span *ngIf="demorequestForm.get('country')?.errors?.['required']">Country is
                                        required.</span>
                                </div>
                            </div>
                            <div class="dis-block-1 p-top-18 p-x-15">
                                <label for="industry" class="dis-flex-4 text_grey_2">Industry*</label>
                                <input type="text" id="industry" formControlName="industry"
                                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                                    placeholder="Enter Industry" required>
                                <div *ngIf="demorequestForm.get('industry')?.touched && demorequestForm.get('industry')?.invalid"
                                    class="text-red-1">
                                    <span *ngIf="demorequestForm.get('industry')?.errors?.['required']">Industry is
                                        required.</span>
                                </div>
                            </div>
                        </div>
                        <div class="p-top-18 p-x-15">
                            <div>
                                <span class="text_grey_2"> How did you hear about ChemRobotics®?</span>
                            </div>
                            <div class="dis-flex-7 flex-wrap p-top-12 ">
                                <div class="m-r-16 p-x-15">
                                    <label>
                                        <input type="checkbox" name="source" value="internet"> Word of Mouth
                                    </label>
                                </div>
                                <div class="m-r-16 p-x-15">
                                    <label>
                                        <input type="checkbox" name="source" value="friend"> Add in magzine
                                    </label>
                                </div>
                                <div class="m-r-16 p-x-15">
                                    <label>
                                        <input type="checkbox" name="source" value="advertisement"> Google Ad
                                    </label>
                                </div>
                                <div class="m-r-16 p-x-15">
                                    <label>
                                        <input type="checkbox" name="source" value="social_media"> Linkdin
                                    </label>
                                </div>
                                <div class="m-r-16 p-x-15">
                                    <label>
                                        <input type="checkbox" name="source" value="event"> Email
                                    </label>
                                </div>
                                <div class="p-x-15">
                                    <label>
                                        <input type="checkbox" name="source" value="other"> Others
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="dis-block-1 p-top-18 p-x-15">
                            <label for="comment" class="dis-flex-4 text_grey_2">Comment</label>
                            <textarea id="comment" formControlName="comment" rows="3"
                                class="dis-flex-4 text_grey_3 border-radius-4 width-100-per p-x-15"
                                placeholder="Write your comment here..."></textarea>
                        </div>
                        <div class="p-top-10 p-b-20 p-x-0 demo_request_bottom">
                            <!-- <div >
                                <div class=" m-t-20 p-x-15" >
                                    <re-captcha 
                                    class="m-t-20"  
                                    [siteKey]="recaptchaSiteKey" 
                                    formControlName="recaptcha">
                                  </re-captcha>
                                </div>
                            </div> -->
                            <div class="m-t-20 p-top-32">
                                <re-captcha
                                  class="m-t-20"
                                  [siteKey]="recaptchaSiteKey"
                                  (resolved)="onCaptchaSuccess($event)"
                                >
                                </re-captcha>
                                <div *ngIf="formSubmitted && !recaptchaResponse">
                                  <small class="text-red-1">Please complete the reCAPTCHA.</small>
                                </div>
                              </div>
                            <div class="demo_request_bottom_submit p-top-20">
                                <button type="submit" class="button_blue_4 text_white_1">Submit</button>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
</div>

<app-footer/>